import { render, staticRenderFns } from "./WeightGainOfDifferentBreed.vue?vue&type=template&id=6d84286a&scoped=true&"
import script from "./WeightGainOfDifferentBreed.vue?vue&type=script&lang=js&"
export * from "./WeightGainOfDifferentBreed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d84286a",
  null
  
)

export default component.exports